import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useTenant } from "@/contexts/tenant-provider";
import { useUser } from "@/contexts/user-provider";
import { useLocations } from "@/hooks/use-locations";

/**
 * The address (before the "@") a staff inbox email starts from: the sender's
 * current location's address, else the clinic's, else the subdomain.
 */
export function useDefaultFromLocalPart() {
  const $ = _c(6);
  const {
    tenant
  } = useTenant();
  const {
    currentLocationId
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      seeAllLocations: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    locations
  } = useLocations(t0);
  let t1;
  if ($[1] !== currentLocationId || $[2] !== locations) {
    let t2;
    if ($[4] !== currentLocationId) {
      t2 = loc => loc.id === currentLocationId;
      $[4] = currentLocationId;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = locations.find(t2);
    $[1] = currentLocationId;
    $[2] = locations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const location = t1;
  return location?.emailFromLocalPart || tenant?.emailFromLocalPart || tenant?.subDomain || "";
}

/**
 * Every address the clinic sends from, lowercased: the clinic's address and
 * each location's (archived ones too, since old threads still carry them).
 * Reply-all drops these so staff never email the clinic itself. Inbound mail
 * stores them as ordinary EXTERNAL contacts, so the contact type alone can't.
 */
export function useClinicOwnEmails() {
  const $ = _c(8);
  const {
    tenant
  } = useTenant();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      seeAllLocations: true,
      includeArchived: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    locations
  } = useLocations(t0);
  const domain = tenant?.transactionalDomain?.domainName;
  tenant?.emailFromLocalPart;
  tenant?.subDomain;
  let t1;
  bb0: {
    if (!domain) {
      let t2;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Set();
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    const t2 = tenant?.emailFromLocalPart || tenant?.subDomain;
    let t3;
    if ($[2] !== locations || $[3] !== t2) {
      t3 = [t2, ...locations.map(_temp)].filter(_temp2);
      $[2] = locations;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    const localParts = t3;
    let t4;
    if ($[5] !== domain || $[6] !== localParts) {
      t4 = new Set(localParts.map(localPart_0 => `${localPart_0}@${domain}`.toLowerCase()));
      $[5] = domain;
      $[6] = localParts;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t1 = t4;
  }
  return t1;
}
function _temp2(localPart) {
  return !!localPart;
}
function _temp(loc) {
  return loc.emailFromLocalPart;
}